/* global $ */
var Proj = (function(proj){
    'use strict';

    var opt = {
	    	mapSelector: '.js-map',
            tabSelector: '.js-tab',
            chemapSelector: '.js-che-map',
            mskmapSelector: '.js-msk-map',
            footerAddressSelector: '.js-footer-address',
            schemeSelector: '.js-scheme_popup',
            headerAddressSelector: '.js-header-address',
            headerScrollAddressSelector: '.js-header-scroll-address',
	    	map: {
	            zoom: 16,
	            center: [55.199090, 61.377850],
	            controls: ['default']
	        },
            mapmsk:{
                zoom: 16,
                center: [55.674570, 37.524246],
                controls: ['default']
            }
	    };

    function initMap() {
	    var $tabs = $(opt.tabSelector),
	        $map = $(opt.mapSelector),
            $scheme = $(opt.schemeSelector),
            $footer = $(opt.footerAddressSelector),
            $header = $(opt.headerAddressSelector),
            $headerScroll = $(opt.headerScrollAddressSelector),
            $msk = $(opt.mskmapSelector),
            $che = $(opt.chemapSelector);

	    if ($tabs.length && $map.length) {
	        ymaps.ready(function() {
	            start();
                if($('.contacts').find(opt.mapmsk)){
                    maps();
                }
	        });
	    }



	    function start() {
            var map = new ymaps.Map($map.get(0), opt.map);

            
            for (var i = 0; i < $tabs.length; i ++) {
                var $tab = $tabs.eq(i),
                    tab = $tab.data();
                tab.coords = tab.coords.split(/[^0-9.]+/);

                var placemark = new ymaps.Placemark(tab.coords, {
                    balloonContentHeader: tab.header,
                    balloonContentBody: tab.content.replace(/\n/g, '<br />')
                }, {
                    preset: 'islands#darkOrangeIcon'
                });
                map.geoObjects.add(placemark);
            }

            $tabs.on('click', function(e) {
            	e.preventDefault();
                showItem($tabs.index(this));
                return false;
            });

            $footer.on('click', function(e) {
                showItem($footer.index(this));
            });

            $header.on('click', function(e) {
                showItem($header.index(this));
            });

            $headerScroll.on('click', function(e) {
                showItem($headerScroll.index(this));
            });

            showItem(0);

            function showItem(i) {
	            $tabs.removeClass('is-active').eq(i).addClass('is-active');
                if ($tabs.eq(0).hasClass('is-active')) {
                    $scheme.addClass('is-active');
                } else {
                    $scheme.removeClass('is-active');
                }

	            map.setCenter($tabs.eq(i).data('coords'), opt.map.zoom);
	        }
        }


        
	}
    
    proj.Map = function(){
        initMap();
    };

    function maps(){        
        var $tabs = $(opt.tabSelector),
            $msk = $(opt.mskmapSelector),
            $che = $(opt.chemapSelector);

        var mapche = new ymaps.Map($che.get(0), opt.map);
        var mapmsk = new ymaps.Map($msk.get(0), opt.mapmsk);

        for (var i = 0; i < $tabs.length; i ++) {
            var $tab = $tabs.eq(i),
                tab = $tab.data();

            var placemark = new ymaps.Placemark(tab.coords, {
                balloonContentHeader: tab.header,
                balloonContentBody: tab.content.replace(/\n/g, '<br />')
            }, {
                preset: 'islands#darkOrangeIcon'
            });
            if(i==1){
                mapmsk.geoObjects.add(placemark);
            }else{
                mapche.geoObjects.add(placemark);
            }
            
        }
    }

    return proj;
})(Proj || {});



